import React from 'react';

import { InputAdornment, MenuItem, TextField, TextFieldProps } from '@mui/material';

import Icons from '../../../../themes/icons';

const options = [
  { key: 'Alphabetical A-Z', value: 'title-asc' },
  { key: 'Alphabetical Z-A', value: 'title-desc' },
  { key: 'Newest', value: 'createdAt-desc' },
  { key: 'Oldest', value: 'createdAt-asc' },
];

export const AlphabetSelect: React.FC<TextFieldProps> = ({ ...rest }) => {
  return (
    <TextField
      select
      size='small'
      sx={{ minWidth: 225, maxWidth: 225 }}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <Icons.AlphabetIcon />
          </InputAdornment>
        ),
      }}
      {...rest}
    >
      {options.map((option) => (
        <MenuItem
          key={option.key}
          sx={{ py: 1.5, backgroundColor: 'transparent', borderBottom: '1px solid rgba(0, 0, 0, 0.08)' }}
          value={option.value}
        >
          {option.key}
        </MenuItem>
      ))}
    </TextField>
  );
};
